import { RotateCw } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import loadSignedInContext from '@/redux/actions/sessionActions/loadSignedInContext.js';
import { sessionContextMessage } from '@/redux/selectors/userSelectors.js';
import Button from '../primitives/Button.jsx';
import EmptyState from '../patterns/EmptyState.jsx';

/** Shown when the session is valid but the account could not be loaded; lets the person try again. */
const AccountLoadError = () => {
  const dispatch = useDispatch();
  const message = useSelector(sessionContextMessage);

  return (
    <div className="comp-boot">
      <EmptyState
        title="Your workspace did not load"
        description={message || 'The connection to Pieve dropped while loading your account. Try again; nothing was lost.'}
        action={
          <Button variant="primary" iconStart={RotateCw} onClick={() => dispatch(loadSignedInContext())}>
            Try again
          </Button>
        }
      />
    </div>
  );
};

export default AccountLoadError;
